function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import react, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useAxios from '../../Hooks/use-axios';
var useData = function useData(_ref) {
  var isPast = _ref.isPast,
    checkProtectedEvents = _ref.checkProtectedEvents,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient,
    config = _ref.config;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    events = _useState2[0],
    setEvents = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedCategories = _useState4[0],
    setSelectedCategories = _useState4[1];
  var _useState5 = useState(1),
    _useState6 = _slicedToArray(_useState5, 2),
    catalyst = _useState6[0],
    setCatalyst = _useState6[1];
  var _useState7 = useState(1),
    _useState8 = _slicedToArray(_useState7, 2),
    totalPages = _useState8[0],
    setTotalPages = _useState8[1];
  var _useState9 = useState(1),
    _useState0 = _slicedToArray(_useState9, 2),
    currentPage = _useState0[0],
    setCurrentPage = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    protectedEventsPresent = _useState10[0],
    setProtectedEventsPresent = _useState10[1];
  var loadMoreHandler = function loadMoreHandler() {
    setCurrentPage(function (prevState) {
      return prevState + 1;
    });
  };
  var authToken = useSelector(function (state) {
    return state.auth.token;
  });
  var isAuthenticated = useSelector(function (state) {
    return state.auth.isAuthenticated;
  });

  // const headers2 = {
  //     'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
  //     Authorization: `Bearer ${authToken}`
  // };
  // const dateCompare = (date) => {
  //     const date2 = new Date(date);
  //     const eventDate = date2.getTime();
  //     const currentDate = today.getTime();

  //     if (currentDate > eventDate) {
  //         // console.log(currentDate, 'greater', eventDate);
  //         return false;
  //     } else {
  //         // console.log(currentDate, 'lesser', eventDate);
  //         return true;
  //     }
  // };

  var onFilterClick = function onFilterClick(tag) {
    setEvents([]);
    if (selectedCategories.includes(tag)) {
      setSelectedCategories(selectedCategories.filter(function (t) {
        return t !== tag;
      }));
    } else {
      setSelectedCategories(selectedCategories.concat(tag));
    }
    if (currentPage === 1) {
      setCatalyst(function (prevState) {
        return prevState + 1;
      });
    } else {
      setCurrentPage(1);
    }
  };
  var _useAxios = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoading = _useAxios.isLoading,
    error = _useAxios.error,
    fetchEvents = _useAxios.sendRequest;
  var _useAxios2 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    loadingProtectedEvents = _useAxios2.isLoading,
    protectedEventsError = _useAxios2.error,
    fetchProtectedEvents = _useAxios2.sendRequest;
  var getProtectedEvents = function getProtectedEvents() {
    // console.log('GET PROTECTED EVENTS');

    var url = "/winnre/no-auth/events/filter-v2?status=PUBLISHED&clientId=".concat(config === null || config === void 0 ? void 0 : config.id, "&isPast=false&isVisibleToAll=false&pageNumber=").concat(currentPage - 1, "&pageSize=20");
    fetchProtectedEvents({
      isEncryptedResponse: true,
      url: url,
      method: 'get',
      isFormData: true
    }, function (data) {
      console.log('EVENTS', data);
      setProtectedEventsPresent((data === null || data === void 0 ? void 0 : data.content.length) > 0);
    });
  };
  var getEvents = function getEvents() {
    // console.log('GET EVENTS', isPast);
    var url;
    if (isAuthenticated) {
      url = "/winnre/user/events/filter-v2?pageNumber=".concat(currentPage - 1, "&status=PUBLISHED&isPast=").concat(isPast, "&sortBy=startDate&isAscending=false&pageSize=4").concat(selectedCategories.length > 0 ? "&tagList=".concat(selectedCategories.join(',')) : '');
    } else {
      url = "/winnre/no-auth/events/filter-v2?status=PUBLISHED&clientId=".concat(config === null || config === void 0 ? void 0 : config.id, "&isPast=").concat(isPast, "&isVisibleToAll=true&sortBy=startDate&isAscending=false&pageNumber=").concat(currentPage - 1, "&pageSize=4").concat(selectedCategories.length > 0 ? "&tagList=".concat(selectedCategories.join(',')) : '');
    }
    fetchEvents({
      isEncryptedResponse: true,
      url: url,
      method: 'get',
      isFormData: true
    }, function (data) {
      console.log('Total EVENTS', data);
      if (isAuthenticated) {
        if ((data === null || data === void 0 ? void 0 : data.status) === 'UNAUTHORIZED') {
          setEvents([]);
          setTotalPages(0);
          return;
        }
        if ((data === null || data === void 0 ? void 0 : data.status) === 'FAILED') {
          setEvents([]);
          setTotalPages(0);
          return;
        }
        if ((data === null || data === void 0 ? void 0 : data.status) === 'TOKEN_EXPIRED') {
          setEvents([]);
          setTotalPages(0);
          return;
        }
        setTotalPages(data === null || data === void 0 ? void 0 : data.totalPages);
        setEvents(function (prevState) {
          return prevState.concat(data.content);
        });
      } else {
        setTotalPages(data.totalPages);
        setEvents(function (prevState) {
          return prevState.concat(data.content);
        });
      }
    });
  };
  useEffect(function () {
    setEvents([]);
    if (isAuthenticated) {
      setCurrentPage(1);
    }
  }, [isAuthenticated]);
  useEffect(function () {
    getEvents();
    if (checkProtectedEvents) {
      getProtectedEvents();
    }
  }, [currentPage, catalyst, selectedCategories, isAuthenticated]);
  return {
    events: events,
    isLoading: isLoading,
    error: error,
    onFilterClick: onFilterClick,
    selectedCategories: selectedCategories,
    currentPage: currentPage,
    setCurrentPage: setCurrentPage,
    loadMoreHandler: loadMoreHandler,
    totalPages: totalPages,
    setEvents: setEvents,
    protectedEventsPresent: protectedEventsPresent
  };
};
export default useData;